import React from "react";
import isEmpty from 'lodash/isEmpty';

import {store} from "../../../configureStore";
import MultiSelectField from './MultiSelectField';
import i18next from 'i18next';

const MultilangSelectFieldListItem = ({item}) => {
    const langByDefault = store.getState().Shops.activeShop.lang_by_default;
    return <span>
        {/*{!isEmpty(item) ? item.name[langByDefault] : '-----'}*/}
        {!isEmpty(item) ? i18next.t(item.name) : '-----'}
    </span>;
};

const MultilangSelectFieldValueInput = ({item}) => {
    const langByDefault = store.getState().Shops.activeShop.lang_by_default;
    return <span>
        {/*{!isEmpty(item) ? item.name[langByDefault] : '-----'}*/}
        {!isEmpty(item) ? i18next.t(item.name) : '-----'}
    </span>;
};

export default class MultilangMultiSelectField extends MultiSelectField {
    itemComponent=MultilangSelectFieldListItem;
    tagComponent=MultilangSelectFieldValueInput;
}
